export const EVENT_STATE_INIT = 'init',
  EVENT_STATE_PRE = 'pre',
  EVENT_STATE_LIVE = 'live',
  EVENT_STATE_POST = 'post',
  EVENT_STATE_ERROR = 'error',
  EVENT_STATE_NOT_FOUND = 'not_found',
  EVENT_STATE_STATE_TIMEOUT_WINDOW = 60000,
  STREAM_TYPE_RTMP = 'rtmp',
  STREAM_TYPE_VOD = 'vod',
  STREAM_TYPE_EXTERNAL = 'external',
  PLAYER_TYPE_UNKNOWN = 'unknown',
  PLAYER_TYPE_HLS_JS = 'hlsjs',
  PLAYER_TYPE_APPLE_MPEG = 'apple.mpegurl',
  PLAYER_STATE_PENDING = 'pending',
  PLAYER_STATE_PAUSED = 'paused',
  PLAYER_STATE_PLAYING = 'playing',
  PLAYER_STATE_SOUND_MUTED = 'SOUND_MUTED',
  PLAYER_STATE_SOUND_ON = 'SOUND_ON',
  PLAYER_STATUS_PLAY = 'play',
  PLAYER_STATUS_PAUSE = 'pause',
  PLAYER_STATUS_ENDED = 'ended',
  PLAYER_STATUS_ERROR = 'error',
  PLAYER_VIEW_FULLSCREEN = 'FULLSCREEN',
  PLAYER_VIEW_STANDARD = 'STANDARD',
  PLAYER_CMD_SOUND_ON = 'CMD_SOUND_ON',
  PLAYER_CMD_SOUND_MUTED = 'CMD_SOUND_MUTED',
  PLAYER_CMD_SOUND_SET_LEVEL = 'CMD_SOUND_SET_LEVEL',
  PLAYER_CMD_JUMP_TO_POSITION = 'CMD_JUMP_TO_POSITION',
  PLAYER_CMD_JUMP_TO_LIVE = 'CMD_JUMP_LIVE',
  PLAYER_CMD_PLAY = 'CMD_PLAY',
  PLAYER_CMD_PAUSE = 'CMD_PAUSE',
  PLAYER_CMD_PLAY_IF_NOT_PAUSED = 'CMD_PLAY_IF_NOT_PAUSED',
  PLAYER_CMD_FULLSCREEN = 'CMD_FULLSCREEN',
  HTTP_ERROR_INTERNAL_SERVER = 'internal server error',
  HTTP_ERROR_NOT_FOUND = 'not found',
  HTTP_ERROR_BAD_REQUEST = 'bad request',
  HTTP_ERROR_UNAUTHORIZED = 'unauthorized',
  HTTP_ERROR_INVALID_JSON = 'invalid json response',
  STREAM_PROVIDER_MUXVOD = 'muxvod',
  STREAM_STATUS_UNKNOWN = 'unknown',
  STREAM_STATUS_IDLE = 'idle',
  STREAM_STATUS_ACTIVE = 'active',
  STREAM_STATUS_DRAFT = 'draft',
  STREAM_STATUS_UNAVAILABLE_EARLY = 'early',
  STREAM_STATUS_UNAVAILABLE_EXPIRED = 'expired',
  STREAM_EXTERNAL_SOURCE_TYPE_ZOOM = 'zoom',
  STREAM_EXTERNAL_SOURCE_TYPE_FACEBOOK = 'facebook',
  STREAM_EXTERNAL_SOURCE_TYPE_YOUTUBE = 'youtube',
  STREAM_EXTERNAL_SOURCE_TYPE_INSTAGRAM = 'instagram',
  STREAM_EXTERNAL_SOURCE_TYPE_TWITCH = 'twitch',
  STREAM_EXTERNAL_SOURCE_TYPE_VIMEO = 'vimeo',
  STREAM_EXTERNAL_SOURCE_TYPE_LINKEDIN = 'linkedin',
  HLS_STATE_STREAM_INACTIVE = 'stream_inactive',
  HLS_STATE_UNABLE_TO_FETCH_STREAM = 'unable_to_fetch',
  HLS_STATE_LOADING = 'loading',
  ERROR_CRITICAL = 'CRITICAL',
  ERROR_WARNING = 'WARNING',
  ERROR_NOTICE = 'NOTICE',
  HOW_DELAYED_IS_TOO_DELAYED = 10,
  DELAY_OK = 'ok',
  DELAY_BEHIND = 'slow',
  DELAY_AHEAD = 'fast',
  COOKIE_VIEWER_TOKEN = 'token.viewer',
  CHAT_COLLAPSE_SIZE = 768,
  CHAT_GENERAL_CHANNEL_NAME = '_',
  MAX_SUBSCRIPTIONS = 10,
  MAX_SUBSCRIPTIONS_MOBILE = 4;

// MixPanel data labels
export const MP_EVENT_ID_LABEL = 'LS Event ID',
  MP_ORGANIZER_ID = 'LS Organizer ID',
  MP_SOURCE_LABEL = 'LS Source',
  MP_PROVIDER_LABEL = 'LS Provider',
  MP_MOD_NAME_LABEL = 'LS Moderator Name',
  MP_USE_REACTIONS_LABEL = 'LS Use Reactions',
  MP_USE_ROOMS_LABEL = 'LS Use Rooms';

// Date formats
export const DATETIME_FORMAT_LOCALIZED_FULL = 'LLLL',
  DATETIME_FORMAT_LOCALIZED_SHORT = 'LLL',
  DATETIME_FORMAT_CHAT_TIMESTAMP = 'h:mm a',
  DATETIME_FORMAT_FULL = 'MM/DD/YY hh:mm A';
